import { Bar, Player, Guild, RaidingParty } from './types';

// List of guild names
const guildNames: string[] = [
    "Sumpan Raiderz",
    "Antes riddare",
    "xxECLIPSExx",
    "Katlagrottan",
    "El Papis",
    "Norrköping Ninjas",
    "Fika Fighters",
    ""
];

// List of player names
const playerNames: string[] = [
    "Kexchoklad",
    "DrickarN",
    "Aleysie",
    "ichigo",
    "Plåt-Pelle",
    ".BjÖrN.",
    "Köttbullar_King",
    "Dala_Horse",
    "IKEA_Assembler",
    "Fika_Fanatic",
    "Surströmming_Lover",
    "Lingonberry_Lad",
    "SaunaSlayer",
    "Knäckebröd_Knight",
    "Volvo_Viking"
];

function getRandomElement<T>(arr: T[]): T {
    return arr[Math.floor(Math.random() * arr.length)];
}

function getRandomInt(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function generateGuilds(): Guild[] {
    return guildNames.map(name => ({
        name,
        members: Array.from({ length: getRandomInt(3, 15) }, () => ({
            name: getRandomElement(playerNames),
            guild: name
        }))
    }));
}

function generateSoloPlayers(count: number): Player[] {
    return Array.from({ length: count }, () => ({
        name: getRandomElement(playerNames)
    }));
}

export function generateRaidingParties(): RaidingParty[] {
    const guilds = generateGuilds();
    const soloPlayers = generateSoloPlayers(30); // Generating 30 solo players

    const totalRaiders = getRandomInt(2, 20);
    const parties: RaidingParty[] = [];

    let remainingRaiders = totalRaiders;

    while (remainingRaiders > 0) {
        if (Math.random() < 0.7 && guilds.length > 0) { // 70% chance of guild party
            const guild = guilds[Math.floor(Math.random() * guilds.length)];
            const partySize = Math.min(remainingRaiders, getRandomInt(1, guild.members.length));
            parties.push({
                players: guild.members.slice(0, partySize),
                singlePlayer: false
            });
            remainingRaiders -= partySize;
        } else {
            const partySize = Math.min(remainingRaiders, getRandomInt(1, 3));
            parties.push({
                players: soloPlayers.splice(0, partySize),
                singlePlayer: true
            });
            remainingRaiders -= partySize;
        }
    }

    return parties;
}